import { render, staticRenderFns } from "./PromotionRejectModal.vue?vue&type=template&id=124d7c93&scoped=true&"
import script from "./PromotionRejectModal.vue?vue&type=script&lang=js&"
export * from "./PromotionRejectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d7c93",
  null
  
)

export default component.exports